import React, { useState, useEffect } from "react";
import { Container, Row, Col, Ratio } from "react-bootstrap";
import RightFooter from "../common/RightFooter";
import t from "../../Utils/Translation";
import { useNavigate } from "react-router-dom";
import MultiActionAreaCard from "./MultiActionAreaCard";
import {
	AUTHORIZED_URL_PREFIX,
	AxiosConfig
} from '../../Utils/Constants';
import Loading from './../common/Loading';
import axios from 'axios';


const Tests = () => {
  const [ isLoading, setIsLoading ] = useState(true);
  const [unitUsage, setUnitUsage] = useState([]);

  useEffect(() => {
		const fetchUnitUsage = async () => {
			try {
				const { data } = await axios.post(`${AUTHORIZED_URL_PREFIX}${"/user/getResultsByType"}`,{type: 'Test'}, AxiosConfig());
				setUnitUsage(data.unitUsage);
                console.log(data.unitUsage);
				setIsLoading(false);
				if (!data.success) {
					console.log('error')
				}
			} catch (error) {
				console.log(error);
			}
		};
		fetchUnitUsage();
		
	}, []);

  const navigate = useNavigate();

  return <div className="lykioccs-main-content lykiocss-test">{isLoading ? <Loading/> : 
       <>
       <Container className="lykiocss-margin-top-5em">
        <Row className="lykiocss-center" style={{marginBottom:'2em'}}>
                <div style={{background: "linear-gradient(to bottom, #960000, #f1414f)",textAlign:'center', color: 'white', padding: '1em', fontSize:'21px', borderRadius:'0.3em'}} >
                    <div>{t('This test - inspired by the Implicit Association Test (IAT) developed by scientists at Harvard University - is a tool designed to detect unconscious associations between concepts that may suggest the presence of biases, meaning tendencies that influence our perception even in contradiction to our beliefs and values.')}</div>
                    <p></p>
                    <div>{t('WARNING: The feedback from the test is based on solid research, but the results are still undergoing validation. The goal of the feedback is to prompt reflection on your possible unconscious biases, not to provide a diagnosis. Therefore, if you are not open to confronting interpretations that you may find questionable, do not proceed further. The test is not considered a necessary step for completing the course. The test results are confidential and will not be disclosed to anyone.')}</div>
                </div>
        </Row>
       </Container>
       <Container>
        <Row className='lykiocss-margin-top-4em'>
            <Col className='lykiocss-margin-top-1em'>
                <MultiActionAreaCard t={t} completed={false} 
                text={t('Start')} duration={5} title={t("GENDER/CAREER")} backgroundColor="#f1414f" lightBackgroundColor="#960000" 
                cover={unitUsage.filter((item) => item.unitId==='t001').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/TEST1-GENERE_CARRIERA.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/test1.jpg"} 
                link={localStorage.getItem("i18n")==="it" ? "/test1" : "/testEN1"} navigate={navigate}/>
            </Col>

            <Col className='lykiocss-margin-top-1em'>
                <MultiActionAreaCard t={t} completed={false} 
                text={t('Start')} duration={5} title={t("AGE")} backgroundColor="#f1414f" lightBackgroundColor="#960000" 
                cover={unitUsage.filter((item) => item.unitId==='t002').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/TEST2-ETA'.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Test2/test2cover.jpg"} 
                link={localStorage.getItem("i18n")==="it" ? "/test2" : "/testEN2"} navigate={navigate}/>
            </Col>

            <Col className='lykiocss-margin-top-1em'>
                <MultiActionAreaCard t={t} completed={false} 
                text={t('Start')} duration={5} backgroundColor="#f1414f" lightBackgroundColor="#960000" title={t("SEXUAL ORIENTATION")} 
                cover={unitUsage.filter((item) => item.unitId==='t003').length>0 ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/tickedCovers/TEST3-ORIENTAMENTO_SESSUALE.jpg" : "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Test3/test3cover.jpg"} 
                link={localStorage.getItem("i18n")==="it" ? "/test3" : "/testEN3"} navigate={navigate}/>
            </Col>

        </Row>
       </Container>
      <RightFooter />
      </>}
      </div> 
};

export default Tests;